import React from "react";
import PortfolioSlider1 from "./reusables/PortfolioSlider1";
import PortfolioSlider2 from "./reusables/PortfolioSlider2";

function Works() {
	return (
		<div id='Portfolio' className='isolate bg-transparent py-20 sm:py-20'>
			<div className='mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='mx-auto max-w-2xl lg:mx-0 lg:max-w-none '>
					<div className='md:max-w-lg md:pr-10 lg:max-w-lg lg:pr-30 '>
						<div className='hidden sm:flex sm:justify-left'>
							<div className='border-b-8 border-gray-900 w-32 my-6'></div>
						</div>
						<p className='mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl text-center sm:text-left'>
							SELECTED WORKS
						</p>
						<p className='mt-6 text-lg leading-8 text-gray-600'>
							Take a look at some of my projects I have done.
						</p>
					</div>
					<PortfolioSlider1 />
					<div className='hidden md:block'>
						<PortfolioSlider2 />
					</div>
				</div>

				{/* Button */}
				<div className='mt-10 flex justify-center gap-x-6'>
					<a
						href='#!'
						className='bg-gray-900 px-7 py-4 text-sm font-bold tracking-wide text-white shadow-sm hover:bg-transparent hover:border-gray-900 hover:text-gray-900 border-2 border-gray-900 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600'>
						GET IN TOUCH <span aria-hidden='true'>&rarr;</span>
					</a>
				</div>
			</div>
		</div>
	);
}

export default Works;
